import { Fragment } from "react/jsx-runtime";


export default function TileSelector({ options, value, onChange, name = 'tileSelector' }) {
  return (
    <div className="flex gap-3">
      {options.map(({ id, label }) => (
        <Fragment key={id}>
          <input
            type="radio"
            name={name}
            id={id}
            value={id}
            checked={value === id}
            onChange={() => onChange(id)}
            className="sr-only"               // hide native radio
          />
          <label
            htmlFor={id}
            className={`
              px-4 py-2 rounded-lg border cursor-pointer transition
              ${value === id
                ? 'bg-[rgb(13,200,207)] text-white border-transparent'
                : 'bg-white text-gray-700 border-gray-300 hover:border-gray-400'
              }
            `}
          >
            {label}
          </label>
        </Fragment>
      ))}
    </div>
  );
}
